export default function CountNumbers() {
    this.init = () => {
        setTimeout (() => {
            initCounterObserver();
        })
    };

    function countNumber(counterElement, duration = 4000, fps = 60) {
        const target = parseInt(counterElement.getAttribute("data-target").replace(/\./g, ""), 10);
        const totalFrames = Math.round(duration / (1000 / fps)); // 240 frames
        const increment = Math.max(1, Math.ceil(target / totalFrames));
        const startTime = performance.now();
    
        const localString = counterElement.getAttribute('data-local') ? counterElement.getAttribute('data-local') : '';
        let currentValue = 0;
    
        counterElement.textContent = localString ? currentValue.toLocaleString(localString) : currentValue;
        const updateCounter = () => {
            const elapsedTime = performance.now() - startTime;
            const expectedValue = Math.min(target, Math.round((elapsedTime / duration) * target));
            currentValue = Math.min(currentValue + increment, expectedValue);
            const valueStr = localString ? currentValue.toLocaleString(localString) : currentValue.toString();
            counterElement.textContent = currentValue < 10 ? `0${valueStr}` : valueStr;
            if (currentValue < target) {
                setTimeout(updateCounter, 1000 / fps);
            } else {
                const valueTargetStr = localString ? currentValue.toLocaleString(localString) : currentValue.toString();
                counterElement.textContent = currentValue < 10 ? `0${valueTargetStr}` : valueTargetStr;
            }
        };
    
        updateCounter();
    }
    

    function initCounterObserver() {
        const counters = document.querySelectorAll(".counter");
        counters.forEach(counter => {
            counter.style.width = counter.clientWidth + "px";
        })
        
        const section = document.querySelector("#counter-section");
        if (!section) return;

        let wScreen = document.body.clientWidth;

        if ((!section.classList.contains('counter-pc') && !section.classList.contains('counter-mb')) || (section.classList.contains('counter-pc') && wScreen >= 768 ) || (section.classList.contains('counter-mb') && wScreen < 768)){
            counters.forEach(counter => {
                const observer = new IntersectionObserver(
                    (entries, observer) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                const duration = 1500;
                                observer.disconnect();

                                countNumber(counter, duration, 60)
                            }
                        });
                    },
                    { threshold: 0.5 }
                );
        
                observer.observe(counter);
            });
            
            
        }
    }
}
